import { StepsORV } from '../../../components/navigation-component/navigation-settings.service';
import { ApplicationStepperLabels } from './application-page.settings';

const NavigationStepperMapper = {
  [ApplicationStepperLabels.FIRST_INSURED]: StepsORV.PERSONAL_DATA,
  [ApplicationStepperLabels.SECOND_INSURED]: StepsORV.PERSONAL_DATA,
  [ApplicationStepperLabels.SECOND_POLICY_HOLDER]: StepsORV.INSURANCE_DATA,
  [ApplicationStepperLabels.BENEFICIARIES]: StepsORV.INSURANCE_DATA,
  [ApplicationStepperLabels.INSURANCE]: StepsORV.INSURANCE_DATA,
  [ApplicationStepperLabels.SUMMARY]: StepsORV.COMPLETE,
  [ApplicationStepperLabels.FINAL]: StepsORV.COMPLETE,
};

export default NavigationStepperMapper;
